

























































































































import { Vue, Component } from "@/shared/vuepack";
import {
  AdminUtilityUserEnableDisableAccount,
  AdminUtilityReindexUser,
  AdminUtilityFraudCheckQueue,
  AdminUtilityMfaDisable,
  PersonalContributionQueue,
  TransactionEdit,
  EmployerRolePermissions,
  AdminEmailChange,
  AdminDobNameChangeUsers,
  QuickSightReportsList,
  CardCustomization,
  CardCustomizationBulkImport,
  LinkedBankAccountManagement,
  ReopenAccountUtilityUsers,
  RiskQuizAgeRevision,
  RiskQuizAgePortfolio,
  AdminUtilityPendingTx,
  AdminUtilityInstantTransferFailures,
  AdminUtilityReimbursementFailures,
  AdminSftpTestFiles,
  InstrumentList,
  AdminUtilityOpenSearch,
  AdminUtilityStateMachine,
  ResetUserCustodian,
  AdminPasswordReset,
  OutageNotificationConfiguration,
  AdminFinicityLinkedAccountsUsers,
  ManageThemes,
  MobileAppList,
  AdminUtilityUmbDeleteLinkedAccount,
  TransferOutCampaigns,
  OmnibusTransactionCodeManagement,
  DWInstrument,
  HsabCpfBlackoutManagement,
  RepointInvestmentAccount,
  InvestmentAccountSearch,
  RepointInvestmentRequests,
  InvestmentAccountClose,
  WexDisableLegacyInvestment
} from "@/admin/route-names";
import { UserPermission } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class AdminUtility extends Vue {
  userStore = useUserStore();
  rolePermissionsStore = useRolePermissionsStore();

  //#region User Section Permissions
  get hasAccountDisablePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUserEnableDisableAccount);
  }
  get hasAdminEmailChangePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUserAdminEmailChange);
  }
  get hasAdminDOBNameChangePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUserAdminDOBNameChange);
  }
  get hasMFADisablePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUserMFADisable);
  }
  get hasPasswordResetPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUserPasswordReset);
  }
  get hasLinkedBankAcctMangEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityLinkedBankAcctMangEdit);
  }
  get hasUMBAccountOpenerEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityUMBAccountOpenerEdit);
  }
  get hasResetUserCustodianEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityResetUserCustodianEdit);
  }
  get hasLinkedFinicityAcctDtlEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityLinkedFinicityAcctDtlEdit);
  }
  get hasDeleteUMBLinkAccountEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDeleteUMBLinkAccountEdit);
  }
  get hasAdminPortalInvestmentAccountCloseUpload (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalInvestmentAccountCloseUpload);
  }
  get isEbtoUser (): boolean {
    return this.userStore.currentUser.groups.some(x => x === "ebto-view" || x === "ebto-edit")
    || this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEbtoView)
    || this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEbtoEdit);
  }
  get hasAdminPortalUtilityRepointUserInvestmentAccountRequestsPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityRepointUserInvestmentAccountRequestsView);
  }
  get hasAdminPortalUtilityRepointUserInvestmentAccountsPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityRepointUserInvestmentAccountsEdit);
  }
  get hasUserPermissions (): boolean {
    return this.hasAccountDisablePermission
      || this.hasAdminEmailChangePermission
      || this.hasAdminDOBNameChangePermission
      || this.hasMFADisablePermission
      || this.hasPasswordResetPermission
      || this.hasLinkedBankAcctMangEditPermission
      || this.hasUMBAccountOpenerEditPermission
      || this.hasResetUserCustodianEditPermission
      || this.hasLinkedFinicityAcctDtlEditPermission
      || this.hasDeleteUMBLinkAccountEditPermission
      || this.isEbtoUser
      || this.hasAdminPortalUtilityRepointUserInvestmentAccountRequestsPermission
      || this.hasAdminPortalUtilityRepointUserInvestmentAccountsPermission
      || this.hasOpenSearchUtilityPermission;
  }
  //#endregion End User Permissions

  //#region Settings Section Permissions
  get hasGlobalRolePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityGlobalRolePermissionEdit);
  }
  get hasQuickSightReportsPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityQuickSightReptEdit);
  }
  get hasDebitCardCustomizationPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDebitCardCustoEdit);
  }
  get hasDrWealthRiskQzPortifoliPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthRiskAgePortEdit);
  }
  get hasAdminPortalDebitCardSettingBulkImport (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDebitCardSettingBulkImport);
  }
  get hasDrWealthRiskQzRevisionPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthRiskAgeReviEdit);
  }
  get hasDrWealthInstrumentLstPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit);
  }
  get hasSftpTestFilesPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilitySftpTestFileEdit);
  }
  get hasOutageNotificationConfigPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityOutageNotifyConfigEdit);
  }
  get hasManageThemesPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityManageThemeEdit);
  }
  get hasMobileApplicationPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityMobileAppsEdit);
  }
  get hasOpenSearchUtilityPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityOpenSearchEdit);
  }

  get hasCpfBlackoutDateManagementPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityCpfBlackoutDateManagementEdit);
  }

  get hasMonitoredStateMachinePermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalMonitoredStateMachines);
  }

  get hasSettingsPermissions (): boolean {
    return this.hasGlobalRolePermission
      || this.hasQuickSightReportsPermission
      || this.hasDebitCardCustomizationPermission
      || this.hasAdminPortalDebitCardSettingBulkImport
      || this.hasDrWealthRiskQzPortifoliPermission
      || this.hasDrWealthRiskQzRevisionPermission
      || this.hasDrWealthInstrumentLstPermission
      || this.hasSftpTestFilesPermission
      || this.hasOutageNotificationConfigPermission
      || this.hasManageThemesPermission
      || this.hasMobileApplicationPermission
      || this.hasOpenSearchUtilityPermission
      || this.hasCpfBlackoutDateManagementPermission;
  }
  //#region End Settings Section Permissions


  //#region transactions Section Permissions
  get hasPersonalContributionsEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPersonalContributionsEdit);
  }
  get hasTransactionEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalTransactionEdit);
  }
  get hasPendingTxClearEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPendingTxClearEdit);
  }
  get hasInstantTransferFailuresEditEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalInstantTransferFailuresEdit);
  }
  get hasReimbursementFailuresEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalReimbursementFailuresEdit);
  }
  get hasOmnibusTransactionCodeManagementPermissionEdit (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalOmnibusTransactionCodeManagementEdit);
  }
  get hasFraudCheckQueueEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalFraudCheckQueueEdit);
  }

  get hasAdminPortalUserManagementEdit (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit);
  }

  get hasTransactionsPermission (): boolean {
    return this.hasPersonalContributionsEditPermission
      || this.hasTransactionEditPermission
      || this.hasPendingTxClearEditPermission
      || this.hasInstantTransferFailuresEditEditPermission
      || this.hasReimbursementFailuresEditPermission
      || this.hasOmnibusTransactionCodeManagementPermissionEdit;
  }
  //#region transactions Section Permissions

  AdminUtilityPendingTx = AdminUtilityPendingTx;
  AdminUtilityInstantTransferFailures = AdminUtilityInstantTransferFailures;
  AdminUtilityReimbursementFailures = AdminUtilityReimbursementFailures;
  AdminUtilityUserEnableDisableAccount = AdminUtilityUserEnableDisableAccount;
  AdminUtilityReindexUser = AdminUtilityReindexUser;
  AdminUtilityFraudCheckQueue = AdminUtilityFraudCheckQueue;
  AdminUtilityMfaDisable = AdminUtilityMfaDisable;
  PersonalContributionQueue = PersonalContributionQueue;
  TransactionEdit = TransactionEdit;
  EmployerRolePermissions = EmployerRolePermissions;
  AdminEmailChange = AdminEmailChange;
  AdminDobNameChangeUsers = AdminDobNameChangeUsers;
  QuickSightReportsList = QuickSightReportsList;
  CardCustomization = CardCustomization;
  CardCustomizationBulkImport = CardCustomizationBulkImport;
  RiskQuizAgePortfolio = RiskQuizAgePortfolio;
  RiskQuizAgeRevision = RiskQuizAgeRevision;
  InstrumentList = InstrumentList;
  AdminUtilityOpenSearch = AdminUtilityOpenSearch;
  AdminUtilityStateMachine = AdminUtilityStateMachine;
  LinkedBankAccountManagement = LinkedBankAccountManagement;
  ReopenAccountUtilityUsers = ReopenAccountUtilityUsers;
  ResetUserCustodian = ResetUserCustodian;
  SftpTestFiles = AdminSftpTestFiles;
  AdminPasswordReset = AdminPasswordReset;
  OutageNotificationConfiguration = OutageNotificationConfiguration;
  AdminFinicityLinkedAccountsUsers = AdminFinicityLinkedAccountsUsers;
  ManageThemes = ManageThemes;
  MobileAppList = MobileAppList;
  AdminUtilityUmbDeleteLinkedAccount = AdminUtilityUmbDeleteLinkedAccount;
  TransferOutCampaigns = TransferOutCampaigns;
  OmnibusTransactionCodeManagement = OmnibusTransactionCodeManagement;
  DWInstrument = DWInstrument;
  HsabCpfBlackoutManagement = HsabCpfBlackoutManagement;
  RepointInvestmentAccount = RepointInvestmentAccount;
  InvestmentAccountSearch = InvestmentAccountSearch;
  RepointInvestmentRequests = RepointInvestmentRequests;
  InvestmentAccountClose = InvestmentAccountClose;
  WexDisableLegacyInvestment = WexDisableLegacyInvestment;
}
